import {useQuery} from '@apollo/react-hooks';
import {type ApolloError} from 'apollo-client';
import {useMemo} from 'react';

import {type RunGrafanaDashboardQueryQuery} from '../../generated/graphql';
import {propagateErrorsContext} from '../../util/errors';
import {RunGrafanaSlurmDashboardQuery} from './runIssuesDashboard.query';
import {useRampFlagCoreweaveIssues} from './useCoreweaveIssues';

type UseRunIssuesDashboardOpts = {
  ranOnCoreweave: boolean;
  entityName: string;
  projectName: string;
  runName?: string;
};

export function useRunIssuesDashboard({
  ranOnCoreweave = false,
  entityName,
  projectName,
  runName,
}: UseRunIssuesDashboardOpts): {
  data: string | undefined;
  loading: boolean;
  error?: ApolloError;
} {
  const canQueryIssues = useRampFlagCoreweaveIssues();
  const {data, loading, error} = useQuery<RunGrafanaDashboardQueryQuery>(
    RunGrafanaSlurmDashboardQuery,
    {
      variables: {
        entityName,
        projectName,
        runName,
      },
      skip: !canQueryIssues || !runName || !ranOnCoreweave,
      context: propagateErrorsContext(),
    }
  );

  return useMemo(
    () => ({
      data: data?.project?.run?.coreweaveGrafanaDashboard ?? '',
      loading,
      error,
    }),
    [data, loading, error]
  );
}
